import { browserHistory } from 'react-router';
import { delay, call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import { arrayRemove } from 'redux-form';
import * as apiCustomForm from '../../services/custom_form/api_custom_form';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import {
  CUSTOM_FORM_SET_LOADING,
  GET_CUSTOM_FORM_DATA,
  SET_CUSTOM_FORM_DATA,
  SET_CUSTOM_FORM_ERROR,
} from '../../constants/constant_action_types';
import { CUSTOM_FORM } from '../../constants/constant_doc_types';
import { CustomFormForm } from '../../constants/constant_form_names';
import { attachRecordListsToCustomForms } from '../../services/apiUtils';
import { fetchAssembledCustomFields } from '../../services/custom_field/api_custom_field';
import { getErrorMessage } from '../../utils';

export function* fetchListCustomFormSaga(app) {
  yield takeLatest('FETCH_LIST_CUSTOM_FORM', callFetchListCustomForm, app);
}

function* callFetchListCustomForm(app, action) {
  const { filters, silent } = action;

  try {
    yield common.showProgressListTable(silent);

    const dataParams = {
      filters,
      list_type: CUSTOM_FORM,
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);

    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* fetchCustomFormForEditSaga(app) {
  yield takeEvery(
    'FETCH_CUSTOM_FORM_FOR_EDIT',
    callFetchCustomFormForEdit,
    app,
  );
}

function* callFetchCustomFormForEdit(app, action) {
  const { id, silent } = action;

  try {
    if (id) {
      yield common.showProgressDataById(silent);

      const params = { id };
      const doc = yield call(apiCustomForm.fetchCustomFormById, app, params);

      yield common.doneDataById(doc);
    }
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}

export function* saveCustomFormSaga(app) {
  yield takeLatest('SAVE_CUSTOM_FORM', callSaveCustomForm, app);
}

function* callSaveCustomForm(app, action) {
  const { tenant, user } = yield select();
  const { data } = action;

  try {
    yield put({ type: 'SAVE_RECORD_INPROGRESS' });

    const params = { data, tenant, user };
    const result = yield call(apiCustomForm.saveCustomForm, app, params);

    yield call(callFetchCustomFormForEdit, app, {
      id: result.id,
      silent: true,
    });

    browserHistory.push(`/admin/custom/form/edit/${result.id}`);

    yield common.doneSaveRecord(result, 'Custom Form was saved');
  } catch (e) {
    yield common.showErrorSaveRecord(e);
  }
}

export function* deleteCustomFormSaga(app) {
  yield takeEvery('DELETE_CUSTOM_FORM', callDeleteCustomForm, app);
}

function* callDeleteCustomForm(app, action) {
  const { tenant, user } = yield select();
  const { id } = action;

  try {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });

    const params = { tenant, user, id };

    yield call(apiCustomForm.deleteCustomForm, app, params);
    yield put({
      type: 'DELETE_RECORD_DONE',
      payload: { id, docType: CUSTOM_FORM },
    });
    yield delay(2000);

    browserHistory.push('/admin/custom/form');
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

export function* getCustomFormTabSettingLinesSaga() {
  yield takeEvery(
    'GET_CUSTOM_FORM_TAB_SETTING_LINES',
    callGetCustomFormTabSettingLines,
  );
}

export function* callGetCustomFormTabSettingLines(action) {
  try {
    const {
      payload: { removedAppliedTo, tabSettings },
    } = action;

    for (const docType of removedAppliedTo) {
      const index = tabSettings.findIndex(
        tabSetting => tabSetting.assigned_doc_type === docType,
      );

      if (index >= 0) {
        yield put(arrayRemove(CustomFormForm, 'tabs', index));
      }
    }
  } catch (e) {
    yield common.showErrorSaveRecord(e);
  }
}

export function* getCustomFormDataSaga(app) {
  yield takeEvery(GET_CUSTOM_FORM_DATA, callGetCustomFormData, app);
}

function* callGetCustomFormData(app, action) {
  const { payload } = action;
  const { type, formId, data } = payload || {};

  try {
    yield put({
      type: CUSTOM_FORM_SET_LOADING,
      payload: formId,
    });

    let customFormData = data;

    if (!customFormData) {
      customFormData = yield call(
        fetchAssembledCustomFields,
        app,
        type,
      );
    }

    customFormData = yield call(
      attachRecordListsToCustomForms,
      app,
      customFormData
    );

    yield put({
      type: SET_CUSTOM_FORM_DATA,
      payload: { formId, data: customFormData },
    });
  } catch (err) {
    yield put({
      type: SET_CUSTOM_FORM_ERROR,
      payload: {
        formId,
        error: getErrorMessage(err),
      }
    });
  }
}

export function* setCustomFromFieldValue() {
  yield takeEvery('@@redux-form/CHANGE', callSetCustomFormFieldValue);
}

function callSetCustomFormFieldValue(action) {
  let { payload, meta } = action;
  let { field } = meta;

  if (field.includes('custom_fields.') || field.includes('custom_fields._errors')) return;

  let value = payload;

  if ((payload || {}).id) {
    field = `${field}_id`;
    value = payload.id;
  }

  const fieldChangeEvent = new CustomEvent('field-change', {
    detail: { field, value },
  });

  window.dispatchEvent(fieldChangeEvent);
}
